const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User created successfully! Please login!!!.",
          fail: "Error creating user. Please check the provided data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          companyName: "Company Name",
          companyNamePlaceholder: "Type your company name",
          phone: "Phone",
          phonePlaceholder: "(00) 00000-0000",
          passwordPlaceholder: "Minimum 5 characters",
          emailPlaceholder: "your@email.com",
        },
        buttons: {
          submit: "Sign up",
          register: "Register",
          login: "Already have an account? Log in!",
          creating: "Creating account...",
          startTrial: "Start {{days}}-day trial",
          selected: "Selected",
          select: "Select",
          backToPlans: "Back to plans",
          loginHere: "Login here",
        },
        validation: {
          passwordTooShort: "Password too short! Minimum 5 characters",
          nameTooShort: "Name too short!",
          nameTooLong: "Name too long!",
          passwordTooLong: "Password too long!",
          invalidEmail: "Invalid email",
          phoneIncomplete: "Incomplete phone number",
          required: "Required",
        },
        steps: {
          selectPlan: "Select your plan",
          createAccount: "Create your account",
        },
        hero: {
          title: "Start your digital journey now.",
          subtitle: "Join hundreds of companies that have already transformed their service with {{appName}}.",
        },
        planCard: {
          popular: "POPULAR",
          perMonth: "/month",
          whatsappConnections: "WhatsApp Connections",
          users: "Users",
          prioritySupport: "Priority support",
          freeDays: "{{days}} days free",
          selectedPlan: "Selected plan:",
        },
        welcomeText: "Welcome!",
        formTitle: "Create your account",
        formSubtitle: "Try it for free for {{days}} days.",
        planSelectionTitle: "Choose the best plan for you:",
        links: {
          agree: "By signing up, you agree to our",
          terms: "Terms of Service",
          privacy: "Privacy Policy",
          and: "and",
        },
        alreadyHaveAccount: "Already have an account?",
      },
      login: {
        title: "Login",
        formTitle: "Access your account",
        formSubtitle: "Track your conversations in real time.",
        hero: {
          title: "Welcome back!",
          subtitle: "Connect with your customers intelligently and efficiently.",
        },
        form: {
          email: "Email",
          password: "Password",
        },
        placeholders: {
          email: "your@email.com",
          password: "••••••••",
        },
        buttons: {
          submit: "Login",
          register: "Sign up now!",
          createAccount: "Create account",
        },
        links: {
          forgotPassword: "Forgot password?",
          noAccount: "Don't have an account?",
        },
      },
      forgetPassword: {
        title: "Reset password",
        hero: {
          title: "Don't worry.",
          subtitle: "Recovering access to your account is simple and fast. Follow the instructions on the side.",
        },
        formTitle: "Recover account",
        formSubtitle: "Enter your email to receive recovery instructions.",
        resetFormSubtitle: "Create a new password for your account.",
        form: {
          email: "Email",
          verificationCode: "Verification Code",
          newPassword: "New password",
          confirmPassword: "Confirm password",
        },
        buttons: {
          resetPassword: "Reset Password",
          sendEmail: "Send Email",
        },
        links: {
          noAccount: "Don't have an account?",
          backToLogin: "Back to login",
        },
        messages: {
          emailNotFound: "Email not found",
          emailSentSuccess: "Email sent successfully!",
          passwordResetSuccess: "Password reset successfully.",
          requiredField: "Required field",
          passwordsDontMatch: "Passwords don't match",
          passwordRequirements: "Your password must have at least 8 characters, including one uppercase letter, one lowercase letter, and one number.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
        },
      },
      cookieConsent: {
        title: "Cookie preferences",
        subtitle: "Customize which cookie categories you allow. You can change this decision at any time.",
        message: "We use cookies and similar technologies to improve your experience on our services, personalize advertising and recommend content of interest to you.",
        disclaimer: "By confirming, we record the date/time of your consent as required by data protection regulations (GDPR/LGPD).",
        buttons: {
          acceptAll: "Accept all",
          decline: "Reject non-essential",
          configure: "Configure preferences",
          save: "Save my choices",
          close: "Close",
        },
        categories: {
          essential: {
            title: "Essential",
            description: "Necessary for authentication, security and basic operation. Cannot be disabled.",
          },
          analytics: {
            title: "Analytics",
            description: "Help understand how you use the platform so we can improve the product. E.g.: Google Analytics.",
          },
          marketing: {
            title: "Marketing",
            description: "Allow personalized campaigns and remarketing. E.g.: social media pixels.",
          },
          functional: {
            title: "Functional",
            description: "Remember your preferences (theme, language, layout) to personalize the experience.",
          },
        },
        policyLink: "View Privacy Policy",
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company created successfully!",
        },
      },
      auth: {
        toasts: {
          success: "Login successful!",
        },
        token: "Token",
      },
      connections: {
        title: "Connections",
        subtitle: "All WhatsApp's",
        status: {
          connected: "Connected",
          disconnected: "Disconnected",
          qrcode: "QR Code",
          timeout: "Timeout",
          connecting: "Connecting",
        },
        labels: {
          default: "Default",
          numberNotDefined: "Number not defined",
          connections: "connections",
        },
        toasts: {
          deleted: "WhatsApp connection deleted successfully!",
          disconnected: "Connection disconnected successfully!",
          connecting: "Connecting...",
          requestingQr: "Requesting new QR Code...",
          restarting: "Please wait... restarting...",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You will need to read the QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "disconnect",
          tryAgain: "Try again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connecting",
          restart: "Restart",
          edit: "Edit",
          delete: "Delete",
        },
        emptyState: {
          title: "No connections found",
          message: 'Click the "Add Connection" button to get started',
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content: "Make sure your phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content: "Click the 'QR CODE' button and scan the QR Code with your phone to start the session",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection with phone was lost",
            content: "Make sure your phone is connected to the internet and WhatsApp is open, or click the 'Disconnect' button to get a new QR Code",
          },
        },
        table: {
          name: "Name",
          number: "Number",
          status: "Status",
          lastUpdate: "Last update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "Assessments",
          integrations: "Integrations",
          schedules: "Business hours",
        },
        form: {
          name: "Name",
          default: "Default",
          sendIdQueue: "Queue",
          timeSendQueue: "Redirect to queue in X minutes",
          queueRedirection: "Queue Redirection",
          outOfHoursMessage: "Out of hours message",
          queueRedirectionDesc: "Select a queue for contacts without a queue to be redirected",
          prompt: "Prompt",
          greetingMedia: "Greeting Media (Optional)",
          attachImage: "Attach Image",
          transferAfterMinutes: "Transfer after x (minutes)",
          transferQueue: "Transfer Queue",
          expiresTicket: "Close open chats after X hours",
          expiresInactiveMessage: "Inactivity closure message",
          //maxUseBotQueues: "Send bot x times",
          //timeUseBotQueues: "Interval in minutes between bot sends",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted successfully!",
          deletedAll: "All contacts deleted successfully!",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          importTitle: "Import contacts",
          deleteMessage: "Are you sure you want to delete this contact? All related tickets will be lost.",
          deleteAllMessage: "Are you sure you want to delete all contacts? All related tickets will be lost.",
          importMessage: "This action will import contacts saved in WhatsApp contacts. Some models may not allow this functionality or according to your privacy settings! Check the result within 1 hour.",
        },
        buttons: {
          import: "Import Contacts",
          importSheet: "Import Excel",
          add: "Add Contact",
          export: "Export Contacts",
          delete: "Delete All Contacts",
          selectAll: "Select All",
          deselectAll: "Deselect All",
          deleteSelected: "Delete",
          deleteAllSelected: "Delete All",
          importExport: "Import / Export",
          exportExcel: "Export Excel",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
          profilePicture: "Profile Picture",
          lastInteraction: "Last Interaction",
          status: "Status",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add project",
          edit: "Edit project",
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Time in minutes to expire a conversation",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Interval (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
      },
      sideMenu: {
        name: "Initial Side Menu",
        note: "If enabled, the side menu will start closed",
        options: {
          enabled: "Open",
          disabled: "Closed",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
        },
        validation: {
          nameTooShort: "Too short!",
          nameTooLong: "Too long!",
          nameRequired: "Required",
          promptTooShort: "Too short!",
          promptRequired: "Describe the training for Artificial Intelligence",
          voiceRequired: "Enter the voice mode",
          maxTokensRequired: "Enter the maximum number of tokens",
          temperatureRequired: "Enter the temperature",
          apikeyRequired: "Enter the API Key",
          queueIdRequired: "Enter the queue",
          maxMessagesRequired: "Enter the maximum number of messages",
        },
        voices: {
          text: "Text",
          francisca: "Francisca",
          antonio: "Antonio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fabio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Leticia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valerio",
          yara: "Yara",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Department/Queue",
          max_tokens: "Max Tokens Response",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
        warning: {
          title: "Important Warning:",
          message: "For all Whaticket users who have noticed an interruption in the operation of OpenAI, we would like to clarify that this is not a system error. OpenAI offers a free credit of $5 USD for new registrations, however, this benefit is also subject to a time limit, usually around three months. When the provided credit runs out, it is necessary to top up the account to continue using the service. It is important to be aware of this policy to ensure a continuous and uninterrupted experience in using OpenAI with Whaticket. If you noticed that the service stopped working, check if your free credit has expired and consider topping up the account if necessary. We are available to help and clarify any additional questions that may arise. Thank you for your understanding and we will continue to work to offer the best possible service to our users.",
          usefulLinks: "Useful Links:",
          usage: "Usage:",
          billing: "Billing:",
          api: "API:",
        },
        toasts: {
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp Number",
          email: "Email",
          emailPlaceholder: "your@email.com",
          birthday: "Birthday",
          extraName: "Field name",
          extraValue: "Value",
          disableBot: "Disable chatbot",
          whatsapp: "Source Connection: ",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        validation: {
          nameRequired: "Required",
          nameTooShort: "Too short! Minimum 2 characters",
          nameTooLong: "Too long! Maximum 50 characters",
          numberRequired: "Enter the number",
          numberInvalid: "Invalid number",
          emailInvalid: "Invalid email",
        },
        success: "Contact saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        tabs: {
          queueData: "Queue Data",
          serviceHours: "Service Hours",
        },
        toasts: {
          deleted: "Record deleted",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          outOfHoursMessage: "Out of hours message",
          ratingMessage: "Rating message",
          token: "Token",
          orderQueue: "Queue order (Bot)",
          integrationId: "Integration",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          attach: "Attach File",
        },
        serviceHours: {
          dayWeek: "Day of week",
          startTimeA: "Start Time - 1",
          endTimeA: "End Time - 1",
          startTimeB: "Start Time - 2",
          endTimeB: "End Time - 2",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      qrCodeModal: {
        title: "QrCode",
        waiting: "Waiting for QR Code generation...",
        instructions: {
          title: "How to connect your WhatsApp:",
          step1: {
            number: "1.",
            text: "Open WhatsApp on your phone",
          },
          step2: {
            number: "2.",
            text: "Tap More options on Android or Settings on iPhone",
          },
          step3: {
            number: "3.",
            text: "Tap Linked Devices and then Link a Device",
          },
          step4: {
            number: "4.",
            text: "Point your phone's camera at this screen to scan the QR Code",
          },
          note: "The QR Code updates automatically every 60 seconds",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
          SuperIs: 'SET SUPERUSER (Admin Only)',
          allTicket: "Ticket Without Queue [Invisible]",
          allTicketEnabled: "Enabled",
          allTicketDesabled: "Disabled",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
        },
        form: {
          body: 'Message',
          contact: 'Contact',
          sendAt: 'Schedule Date',
          sentAt: 'Sent Date',
          geral: 'Open Ticket?',
          sendBy: "Send by...",
        },
        recurrence: {
          day: "day",
          days: "days",
          everyDay: "Every day",
          daysOfWeek: {
            sunday: "Sunday",
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
          },
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          attachMedia: "Attach Media",
        },
        success: "Schedule saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
        },
        form: {
          name: "Name",
          color: "Color",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "DRAG AND DROP FILES INTO THE FIELD BELOW",
          titleFileList: "File list",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
          closeallTicket: "Close",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolverd: "Resolved",
        },
        toasts: {
          deleted: "The ticket you were on was deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: {
            title: "Open"
          },
          closed: {
            title: "Resolved"
          },
          search: {
            title: "Search"
          },
        },
        search: {
          placeholder: "Search tickets and messages",
          filterConnections: "Filter by connections",
          filterContacts: "Filter by contact",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterTags: "Filter by Tags",
          filterStatus: "Filter by Status",
          ticketsPerPage: "Tickets per page",
          groups: "Groups",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search users",
        fieldQueueLabel: "Transfer to queue",
        fieldQueuePlaceholder: "Select a queue",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        called: "Ticket",
        pendingHeader: "Pending",
        assignedHeader: "Attending",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No ticket found with this status or search term",
        buttons: {
          accept: "Accept",
          closed: "Finish",
          transfer: "Transfer",
          reopen: "Reopen",
          exportAsPDF: "Export to PDF",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search contact",
        add: "Add",
        selectQueue: "Select a queue",
        selectConnection: "Select a Connection",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        sections: {
          atendimento: "Service",
          gerencia: "Management",
          campanhas: "Campaigns",
          administracao: "Administration",
          sistema: "System",
        },
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          quickMessages: "Quick Answers",
          contacts: "Contacts",
          kanban: "Kanban",
          queues: "Queues & Chatbot",
          tags: "Tags",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
          helps: "Help",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          listagem: "Listing",
          contactLists: "Contact Lists",
          campaignsConfig: "Settings",
          annoucements: "Announcements",
          backups: "Backups",
          tasks: "Tasks",
          chats: "Internal Chat",
          financeiro: "Finance",
          files: "File list",
          prompts: "OpenAI",
          reports: "Reports",
          queueIntegration: "Integrations",
        },
        appBar: {
          notRegister: "No notifications",
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone! and will be removed from linked queues and connections",
        },
      },
      reports: {
        title: "Ticket Reports",
        labels: {
          contact: "Contact",
          dateFrom: "Initial Date",
          dateTo: "Final Date",
        },
        tooltips: {
          exportExcel: "Export to Excel",
          accessTicket: "Access Ticket",
        },
        status: {
          open: "OPEN",
          closed: "CLOSED",
          pending: "PENDING",
          noQueue: "NO QUEUE",
        },
        messages: {
          noPermissionFilterUsers: "You do not have permission to filter tickets from other users",
        },
        excel: {
          sheetName: "TicketReports",
          fileName: "ticket-reports.xlsx",
        },
        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Client",
          supportTime: "Support Time",
        },
        buttons: {
          filter: "Apply Filter",
        },
        searchPlaceholder: "Search...",
      },
      files: {
        title: "File list",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "List deleted successfully!",
          deletedAll: "All lists deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
      },
      messagesAPI: {
        title: "Message sending documentation",
        sections: {
          sendMethods: "Sending Methods",
          textMessages: "Text Messages",
          mediaMessages: "Media Messages",
          instructions: "Instructions",
          textMessagesTitle: "1. Text Messages",
          mediaMessagesTitle: "2. Media Messages",
          testSend: "Test Send",
        },
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered token",
          description: "Below is the list of information needed to send text messages:",
          endpoint: "Endpoint",
          method: "Method",
          headers: "Headers",
          headersValue: "Authorization (Bearer token) and Content-Type (application/json)",
          bodyExample: "Your message",
        },
        mediaMessage: {
          number: "Number",
          body: "File name",
          media: "File",
          token: "Registered token",
          description: "Below is the list of information needed to send media messages:",
          endpoint: "Endpoint",
          method: "Method",
          headers: "Headers",
          headersValue: "Authorization (Bearer token) and Content-Type (multipart/form-data)",
          formData: "FormData",
          file: "file",
          selectFile: "No file chosen",
        },
        buttons: {
          send: "Send",
        },
        toasts: {
          messageSent: "Message sent successfully",
        },
        notes: {
          title: "Important notes",
          tokenNote: "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. To register, access the \"Connections\" menu, click the edit button of the connection and enter the token in the appropriate field.",
          numberFormat: "The number for sending should not have a mask or special characters and should be composed of:",
          countryCode: "Country code",
          areaCode: "Area code",
          number: "Number",
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      quickMessages: {
        title: "Quick Answers",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          geral: "Global",
          add: "Add",
          edit: "Edit",
          visao: "Allow viewing",
          active: "Active",
          inactive: "Inactive",
          editBeforeSend: "Edit before sending",
        },
        validation: {
          required: "Required",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "Filename",
          status: 'Global',
        },
      },
      messageVariablesPicker: {
        label: "Available variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          greeting: "Greeting",
          protocolNumber: "Protocol",
          date: "Date",
          hour: "Time",
        },
      },
      dashboard: {
        cards: {
          activeConnections: "Active Connections",
          companies: "Companies",
          inConversation: "In Conversation",
          waiting: "Waiting",
          newContacts: "New Contacts",
          avgConversationTime: "Avg. Conversation Time",
          finished: "Finished",
          avgWaitTime: "Avg. Wait Time",
        },
        filters: {
          filterType: "Filter Type",
          dateFilter: "Date Filter",
          periodFilter: "Period Filter",
          dateFrom: "Start Date",
          dateTo: "End Date",
          period: "Period",
          noneSelected: "None selected",
          last3Days: "Last 3 days",
          last7Days: "Last 7 days",
          last15Days: "Last 15 days",
          last30Days: "Last 30 days",
          last60Days: "Last 60 days",
          last90Days: "Last 90 days",
          filter: "Filter",
        },
        messages: {
          parameterizeFilter: "Please set filter parameters",
        },
        charts: {
          ticketsCreated: "Tickets Created: ",
          tickets: "Tickets",
          conversationsChart: "Conversations Chart",
          quantity: "Quantity",
          hourOfDay: "Hour of Day",
          errorLoadingData: "Error loading ticket information",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage: "Do you want to import contacts from this sheet? ",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted",
        },
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
          stopCampaign: "Stop Campaign",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          status: "Status",
          scheduledAt: "Schedule",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
          notDefinedQueue: "Not defined",
          notDefinedWhatsapp: "Not defined",
          noSchedule: "No schedule",
          notCompleted: "Not completed",
          statusInactive: "Inactive",
          statusScheduled: "Scheduled",
          statusInProgress: "In Progress",
          statusCancelled: "Cancelled",
          statusFinished: "Finished",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tag List",
            fileList: "File List",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sends",
            restart: "Restart Sends",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation successful",
          cancel: "Campaign cancelled",
          restart: "Campaign restarted",
          deleted: "Record deleted",
        },
      },
      announcements: {
        active: 'Active',
        inactive: 'Inactive',
        title: "Announcements",
        searchPlaceholder: "Search",
        priority: {
          high: "High",
          average: "Average",
          low: "Low",
        },
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation successful",
          deleted: "Record deleted",
        },
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          id: "ID",
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
          orderQueue: "Queue ordering (bot)",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone! The tickets in this queue will still exist, but will no longer have any queue assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      users: {
        title: "Users",
        table: {
          id: "ID",
          name: "Name",
          status: "Status",
          email: "Email",
          profile: "Profile",
          actions: "Actions",
        },
        status: {
          online: "Online users",
          offline: "Offline users",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "All user data will be lost. Open tickets from this user will be moved to the queue.",
        },
      },
      helps: {
        title: "Help Center",
      },
      schedules: {
        title: "Schedules",
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Schedule Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        tooltips: {
          edit: "Edit",
          delete: "Delete",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
        messages: {
          noEventsInRange: "No schedules in this period.",
        },
        calendar: {
          month: "Month",
          next: "Next",
          tomorrow: "Tomorrow",
          previous: "Previous",
          today: "Today",
          yesterday: "Yesterday",
          week: "Week",
          day: "Day",
          agenda: "Agenda",
          allDay: "All Day",
          date: "Date",
          time: "Time",
          event: "Event",
          showMore: "more",
        },
        tooltips: {
          edit: "Edit",
          delete: "Delete",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
          deleteAllMessage: "Are you sure you want to delete all Tags?",
          deleteAllTitle: "Delete All",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tagged Records",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
          deleteAll: "Delete All",
        },
        toasts: {
          deletedAll: "All Tags deleted successfully!",
          deleted: "Tag deleted successfully.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      settingsCustom: {
        tabs: {
          options: "Options",
          schedules: "Schedules",
          logo: "Logo",
          companies: "Companies",
          newCompany: "Register Company",
          plans: "Plans",
          helps: "Help",
        },
        toasts: {
          schedulesUpdated: "Schedules updated successfully.",
        },
        uploader: {
          tab: {
            logosIcons: "Logos / Icons",
          },
          labels: {
            chooseOption: "Choose an option:",
            chooseImage: "Choose PNG image",
          },
          options: {
            signup: "Signup Screen",
            login: "Login Screen",
            interno: "Internal Logo",
            logoDark: "Dark Logo",
            favicon: "Favicon.Ico",
          },
          buttons: {
            sendFile: "SEND FILE",
          },
          messages: {
            noPermission: "No permission to access!",
            chooseFile: "Choose a file!",
            chooseDestination: "Choose a destination!",
            fileSentSuccess: "File sent successfully!",
            invalidFileFormat: "Use only files in PNG, ICO or SVG format!",
          },
        },
      },
      settingsOptions: {
        labels: {
          ratings: "Ratings",
          scheduleManagement: "Business Hours Management",
          ignoreGroupMessages: "Ignore Group Messages",
          acceptCall: "Accept Call",
          chatbotType: "Chatbot Type",
          sendGreetingAccepted: "Send greeting when accepting ticket",
          sendTransferMessage: "Send transfer message for Queue/agent",
          birthdayReminder: "Enable/Disable birthday reminder",
          holidayPeriod: "Enable/Disable holiday/recess message",
          holidayPeriodAllowQueueFlow: "Queue works even during recess",
          sendGreetingOneQueue: "Send greeting when there is only 1 queue",
          viewClosedTickets: "Operator Views Closed Tickets?",
          viewGroups: "Operator Views Groups?",
          allowRegister: "Registration (Signup) Allowed?",
          viewRegister: "Registration (Signup) Visible?",
          trialTime: "Trial Time?",
          globalSettings: "Global Settings",
          integrations: "INTEGRATIONS",
          asaas: "ASAAS",
          mercadoPago: "MERCADO PAGO",
          geminiAI: "GEMINI AI",
          paymentProvider: "Payment provider",
          environment: "Environment",
          webhookUrl: "Webhook URL",
          selectGeminiModel: "Select Gemini Model",
          geminiApiToken: "Gemini API Token",
        },
        options: {
          disabled: "Disabled",
          enabled: "Enabled",
          no: "No",
          yes: "Yes",
          scheduleDisabled: "Disabled",
          scheduleQueue: "Queue",
          scheduleCompany: "Company",
          callDisabled: "Don't Accept",
          callEnabled: "Accept",
          chatbotText: "Text",
          environmentProduction: "Production",
          environmentSandbox: "Sandbox",
          paymentProviderGerencianet: "Gerencianet (Current)",
          paymentProviderMercadoPago: "Mercado Pago",
        },
        placeholders: {
          greetingMessage: "E.g.: {{ms}} {{name}}, my name is {{agent}} and I will proceed with your service!",
          transferMessage: "E.g.: {{ms}} {{name}}, your service was transferred. Department: {{queue}}. Agent: {{agent}}.",
          birthdayMessage: "E.g.: Congratulations {{name}}! 🎉🎂 We wish you a happy birthday! May you have {{idade}} years of much happiness!",
          webhookUrl: "https://api.yourapp.com/subscription/webhook",
        },
        helperTexts: {
          updating: "Updating...",
          saving: "Saving...",
          saveMessage: "Save message",
          saveTime: "Save time",
          greetingVariables: "Available variables: {{ms}} (greeting), {{name}} (contact name), {{agent}} (agent)",
          transferVariables: "Available variables: {{ms}} (greeting), {{name}} (contact name), {{agent}} (new agent), {{queue}} (current queue), {{previousAgent}} (previous agent), {{previousQueue}} (previous queue)",
          birthdayVariables: "Available variables: {{name}} (contact name), {{idade}} (contact age)",
          holidayPeriodFlow: "When enabled, queue flow continues to work during recess, but without service",
          configureHolidayPeriod: "Configure holiday/recess periods in WhatsApp connection settings",
          triggerTime: "Time when birthday messages will be sent (format: HH:MM)",
          webhookUrlExample: "Webhook URL for validation. Example: https://api.yourapp.com/subscription/webhook",
          validatingWebhook: "Testing URL accessibility...",
          validateWebhook: "Validate Webhook",
          gerencianetClientId: "Gerencianet application Client ID",
          gerencianetClientSecret: "Gerencianet application Client Secret",
          gerencianetPixKey: "PIX key used in Gerencianet charges",
          uploadingCert: "Uploading certificate...",
          loadCert: "Load certificate (.p12)",
          certCurrent: "Current certificate:",
          noCert: "No certificate uploaded",
          mercadoPagoPublicKey: "Enter Mercado Pago public key",
          mercadoPagoAccessToken: "Enter Mercado Pago access token",
          mercadoPagoWebhookSecret: "Webhook secret signature (found in Mercado Pago panel in 'Configure Webhook Notifications' → 'Secret signature' field)",
          mercadoPagoWebhookSecretOptional: "⚠️ Optional, but recommended for greater security. Copy from the \"Secret signature\" field in the Mercado Pago panel.",
          geminiApiToken: "Configure Google Gemini API token to enable automatic message suggestions",
          geminiCurrentModel: "Current model:",
          asaasToken: "Asaas Token",
        },
        messages: {
          greetingMessage: "Greeting message",
          transferMessage: "Transfer message",
          birthdayMessage: "Birthday message",
          triggerTime: "Trigger time",
        },
        toasts: {
          operationUpdated: "Operation updated successfully.",
          greetingMessageUpdated: "Greeting message updated successfully.",
          transferMessageUpdated: "Transfer message updated successfully.",
          birthdayReminderUpdated: "Birthday reminder updated successfully.",
          birthdayMessageUpdated: "Birthday message updated successfully.",
          birthdayTimeUpdated: "Birthday trigger time updated successfully. The system will be restarted to apply the changes.",
          holidayPeriodUpdated: "Holiday/recess message updated successfully.",
          holidayPeriodFlowUpdated: "Recess flow configuration updated successfully.",
          gerencianetEnvironmentUpdated: "Gerencianet environment updated successfully.",
          gerencianetClientIdUpdated: "Gerencianet Client ID updated successfully.",
          gerencianetClientSecretUpdated: "Gerencianet Client Secret updated successfully.",
          gerencianetPixKeyUpdated: "Gerencianet PIX key updated successfully.",
          gerencianetCertUploaded: "Gerencianet certificate uploaded successfully.",
          gerencianetCertWarning: "Certificate uploaded, but could not update configuration automatically.",
          gerencianetCertError: "Could not upload Gerencianet certificate.",
          webhookUrlRequired: "Please enter the webhook URL.",
          webhookValidated: "✅",
          webhookError: "❌",
          mercadoPagoPublicKeyUpdated: "Mercado Pago public key updated successfully.",
          mercadoPagoAccessTokenUpdated: "Mercado Pago access token updated successfully.",
          mercadoPagoWebhookSecretUpdated: "Mercado Pago webhook secret key updated successfully.",
          paymentProviderUpdated: "Payment provider updated successfully.",
          geminiTokenUpdated: "Gemini token updated successfully.",
          certFormatError: "Send a certificate in .p12 format.",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            reject: "Reject",
            transfer: "Transfer",
            close: "Close",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        attachments: {
          image: "Image",
          document: "Document",
          video: "Video",
          location: "Location",
          audio: "Audio",
        },
      },
      mediaModal: {
        title: "Send Media",
        caption: "Caption (optional)",
        captionPlaceholder: "Type a caption for the file...",
        addMore: "Add more",
        dragDropText: "Drop files here to send",
        buttons: {
          cancel: "Cancel",
          send: "Send",
        },
        maxFiles: "Maximum 10 files allowed",
      },
      messageSearch: {
        placeholder: "Search messages...",
        noResults: "No messages found",
        searchButton: "Search messages",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
          cancel: "Cancel",
          save: "Save",
        },
        extraInfo: "Other information",
        contactNotes: "Contact Notes",
        note: "Note",
        notePlaceholder: "Enter the information you want to record here",
        errors: {
          invalidUrl: "Invalid URL:",
        },
      },
      fileModal: {
        title: {
          add: "Add file list",
          edit: "Edit file list",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add file",
        },
        form: {
          name: "File list name",
          message: "List details",
          fileOptions: "File list",
          extraName: "Message to send with file",
          extraValue: "Option value",
        },
        success: "File list saved successfully!",
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        appointmentsModal: {
          title: "Contact Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to record here",
        },
        confirmationModal: {
          title: "Delete ticket",
          titleFrom: "from contact ",
          message: "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reactionSuccess: "Reaction added",
        reply: "Reply",
        edit: 'Edit Message',
        forward: "Forward",
        toForward: "Forward",
        react: "React",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "There must be at least one default WhatsApp.",
        ERR_NO_DEF_WAPP_FOUND: "No default WhatsApp found. Check the connections page.",
        ERR_WAPP_NOT_INITIALIZED: "This WhatsApp session has not been initialized. Check the connections page.",
        ERR_WAPP_CHECK_CONTACT: "Could not check WhatsApp contact. Check the connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid WhatsApp number.",
        ERR_WAPP_DOWNLOAD_MEDIA: "Could not download WhatsApp media. Check the connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG: "Error sending WhatsApp message. Check the connections page.",
        ERR_DELETE_WAPP_MSG: "Could not delete WhatsApp message.",
        ERR_OTHER_OPEN_TICKET: "There is already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please log in.",
        ERR_USER_CREATION_DISABLED: "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You do not have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error creating message in database.",
        ERR_CREATING_TICKET: "Error creating ticket in database.",
        ERR_FETCH_WAPP_MSG: "Error fetching message from WhatsApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED: "Greeting message is required when there is more than one queue.",
        ERR_CHECK_NUMBER: "Invalid number. Check the number and try again.",
      },

      queueOptions: {
        title: "Title not defined",
        placeholder: {
          optionText: "Type the option text",
          integrationUrl: "Type the integration URL (N8N / TypeBOT ...)",
        },
        labels: {
          optionType: "Option type",
          selectQueue: "Select a Queue",
          selectAttendant: "Select an Agent",
        },
        types: {
          text: "Text",
          attendant: "Agent",
          queue: "Queue",
          n8n: "External (API)",
        },
        buttons: {
          add: "Add",
          options: "Options",
        },
      },
      holidayPeriodManager: {
        title: "Recess/Holidays",
        buttons: {
          addPeriod: "Add Period",
          cancel: "Cancel",
          save: "Save",
        },
        labels: {
          startDate: "Start Date",
          endDate: "End Date",
          message: "Message",
          repeatInterval: "Repeat message every (hours)",
          active: "Active",
        },
        placeholders: {
          message: "Ex.: We are on recess from {{startDate}} to {{endDate}}. We will return shortly!",
        },
        helperText: {
          variables: "Available variables: {{startDate}} (start date), {{endDate}} (end date), {{name}} (contact name), {{ms}} (greeting)",
        },
        intervals: {
          hour1: "1 hour",
          hour2: "2 hours",
          hour3: "3 hours",
          hour6: "6 hours",
          hour12: "12 hours",
          hour24: "24 hours (1 day)",
          hour48: "48 hours (2 days)",
          hour72: "72 hours (3 days)",
        },
        dialog: {
          editTitle: "Edit Period",
          newTitle: "New Recess/Holiday Period",
        },
        status: {
          active: "Active",
          inactive: "Inactive",
          activeNow: "⚠️ Period active now",
        },
        dates: {
          from: "From:",
          to: "To:",
        },
        messages: {
          noPeriods: "No recess/holiday period configured",
          fillRequired: "Fill in all required fields",
          dateError: "Start date must be before end date",
          updated: "Period updated successfully!",
          created: "Period created successfully!",
          deleted: "Period deleted successfully!",
          confirmDelete: "Are you sure you want to delete this period?",
        },
      },
      campaignModal: {
        helperText: {
          variables: "Use variables like {name}, {number}, {email} or define custom variables.",
        },
        tabs: {
          message1: "Msg. 1",
          message2: "Msg. 2",
          message3: "Msg. 3",
          message4: "Msg. 4",
          message5: "Msg. 5",
        },
        errors: {
          generic: "Error processing request",
        },
      },
      toastError: {
        generic: "An error occurred!",
      },
      backups: {
        title: "System Backups",
        buttons: {
          create: "Create Backup",
          download: "Download",
          delete: "Delete",
          cancel: "Cancel",
          previous: "Previous",
          next: "Next",
        },
        table: {
          name: "Name",
          size: "Size",
          createdAt: "Creation Date",
          actions: "Actions",
        },
        placeholders: {
          search: "Search backups...",
        },
        status: {
          started: "Started",
          preparing: "Preparing...",
          database: "Backing up database...",
          backend: "Backing up backend...",
          frontend: "Backing up frontend...",
          compressing: "Compressing...",
          completed: "Completed",
          error: "Error",
        },
        messages: {
          noBackups: "No backups found",
          errorCreating: "Error creating backup:",
          unknownError: "Unknown error",
          creating: "Creating Backup...",
          error: "Error:",
          important: "Important:",
          importantNote: "It is always recommended to backup the VPS through snapshot and also perform backups regularly at night due to the duration of the process. Backups include the complete database and all system files (backend and frontend).",
          confirmDelete: "Confirm Deletion",
          confirmDeleteMessage: "Are you sure you want to delete the backup \"{{name}}\"? This action will not affect the system, it will only remove the backup file.",
          page: "Page",
          of: "of",
          databaseBackupError: "Could not backup the database. Make sure mysqldump/pg_dump is installed.",
          tempDirNotFound: "Temporary directory not found for compression",
          noFilesToCompress: "No files found to compress",
          zipCreationFailed: "Failed to create ZIP file",
          unsupportedDatabaseDialect: "Unsupported database dialect",
        },
        toasts: {
          accessDenied: "Access denied. Only superadmin can access this page.",
          completed: "Backup completed successfully!",
          started: "Backup started. Please wait for completion...",
          deleted: "Backup deleted successfully",
          downloadStarted: "Download started",
          error: "Error creating backup",
        },
        formatBytes: {
          zero: "0 Bytes",
          bytes: "Bytes",
          kb: "KB",
          mb: "MB",
          gb: "GB",
        },
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
        tabs: {
          chats: "Chats",
          messages: "Messages",
        },
        dialog: {
          title: "Conversation",
          labels: {
            title: "Title",
          },
          placeholders: {
            title: "Title",
          },
          alerts: {
            fillTitle: "Please fill in the conversation title.",
            selectUser: "Please select at least one user.",
          },
          buttons: {
            close: "Close",
            save: "Save",
          },
        },
        buttons: {
          new: "New",
          newChat: "New",
        },
        confirmationModal: {
          deleteTitle: "Delete Conversation",
          deleteMessage: "This action cannot be undone, confirm?",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
        sections: {
          intervals: "Intervals",
        },
        toasts: {
          saved: "Settings saved",
        },
        labels: {
          randomInterval: "Random Send Interval",
          greaterInterval: "Greater Send Interval",
          greaterIntervalAfter: "Greater Interval After",
          shortcut: "Shortcut",
          content: "Content",
        },
        intervals: {
          noInterval: "No Interval",
          notDefined: "Not defined",
          seconds: "seconds",
          second: "second",
        },
        buttons: {
          addVariable: "Add Variable",
          saveSettings: "Save Settings",
          close: "Close",
          add: "Add",
        },
        table: {
          shortcut: "Shortcut",
          content: "Content",
        },
      },
      campaignReport: {
        titles: {
          validContacts: "Valid Contacts",
          requestedConfirmations: "Requested Confirmations",
          confirmations: "Confirmations",
          delivered: "Delivered",
          connection: "Connection",
          contactList: "Contact List",
          scheduled: "Scheduling",
          completion: "Completion",
        },
      },

      contactListItems: {
        tooltips: {
          validWhatsapp: "Valid Whatsapp",
          invalidWhatsapp: "Invalid Whatsapp",
        },
      },
      announcementModal: {
        validation: {
          titleRequired: "Required",
          textRequired: "Required",
        },
      },
      financeiro: {
        title: "Invoices",
        table: {
          id: "Id",
          details: "Details",
          value: "Value",
          dueDate: "Due Date",
          status: {
            label: "Status",
            paid: "Paid",
            overdue: "Overdue",
            open: "Open",
          },
          action: "Action",
        },
        buttons: {
          pay: "PAY",
          paid: "PAID",
        },
      },
      checkoutPage: {
        title: "Almost there!",
        steps: {
          data: "Data",
          customize: "Customize",
          review: "Review",
        },
        buttons: {
          back: "BACK",
          next: "NEXT",
          pay: "PAY",
        },
        addressForm: {
          title: "We'll need some information",
        },
        paymentForm: {
          month: "/month",
          users: "Users",
          connections: "Connection",
          queues: "Queues",
          select: "SELECT",
        },
        reviewOrder: {
          title: "Subscription summary",
          planDetails: {
            title: "Plan details",
            users: "Users:",
            whatsapps: "Whatsapps:",
            billing: "Billing: Monthly",
            total: "Total:",
          },
          paymentInfo: {
            title: "Payment information",
            email: "Email:",
            name: "Name:",
            address: "Address:",
            total: "Total:",
          },
        },
        checkoutSuccess: {
          total: "TOTAL",
          emailForBilling: "Email for billing:",
          copyPix: "Copy PIX",
          copied: "Copied",
          instructions: "To finish, just make the payment by scanning or pasting the Pix code above :)",
          licenseRenewed: "Your license has been renewed until {{date}}!",
        },
        toasts: {
          subscriptionSuccess: "Subscription completed successfully!, waiting for payment",
        },
        formModel: {
          firstName: {
            label: "Full name*",
            requiredErrorMsg: "Full name is required",
          },
          lastName: {
            label: "Last name*",
            requiredErrorMsg: "Last name is required",
          },
          address1: {
            label: "Address*",
            requiredErrorMsg: "Address is required",
          },
          city: {
            label: "City*",
            requiredErrorMsg: "City is required",
          },
          state: {
            label: "State*",
            requiredErrorMsg: "State is required",
          },
          zipcode: {
            label: "ZIP Code*",
            requiredErrorMsg: "ZIP Code is required",
            invalidErrorMsg: "Invalid ZIP Code format",
          },
          country: {
            label: "Country*",
            requiredErrorMsg: "Country is required",
          },
          nameOnCard: {
            label: "Name on card*",
            requiredErrorMsg: "Name on card is required",
          },
          cardNumber: {
            label: "Card number*",
            requiredErrorMsg: "Card number is required",
            invalidErrorMsg: "Invalid card number (e.g.: 4111111111111)",
          },
          expiryDate: {
            label: "Expiry date*",
            requiredErrorMsg: "Expiry date is required",
            invalidErrorMsg: "Invalid expiry date",
          },
          cvv: {
            label: "CVV*",
            requiredErrorMsg: "CVV is required",
            invalidErrorMsg: "Invalid CVV (e.g.: 357)",
          },
          useAddressForPaymentDetails: {
            label: "Use this address for payment details",
          },
          invoiceId: {
            label: "Use this invoiceId",
          },
        },
      },
      companiesManager: {
        labels: {
          recurrence: "Recurrence",
        },
        status: {
          no: "No",
          yes: "Yes",
        },
        toasts: {
          loadError: "Could not load record list",
          success: "Operation performed successfully!",
          operationError: "Could not perform operation. Check if a company with the same name already exists or if fields were filled correctly",
        },
        confirmationModal: {
          deleteTitle: "Record Deletion",
        },
      },
      contactNotesDialog: {
        toasts: {
          added: "Note added successfully!",
          deleted: "Note deleted successfully!",
        },
      },
      messageInputCustom: {
        errors: {
          locationError: "Error getting location: ",
          geolocationNotSupported: "Geolocation not supported by browser",
          maxFiles: "Maximum 100 files allowed",
        },
        labels: {
          video: "Video",
          location: "Location",
        },
      },
      campaignReport: {
        titles: {
          validContacts: "Valid Contacts",
          requestedConfirmations: "Requested Confirmations",
          confirmations: "Confirmations",
          delivered: "Delivered",
          connection: "Connection",
          contactList: "Contact List",
          scheduled: "Schedule",
          completion: "Completion",
        },
      },
      pages: {
        toasts: {
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
        },
        errors: {
          getTicketsInfo: "Error getting ticket information",
          getConversationInfo: "Error getting conversation information",
        },
      },
      dashboard: {
        cards: {
          activeConnections: "Active Connections",
          companies: "Companies",
          inConversation: "In Conversation",
          waiting: "Waiting",
          newContacts: "New Contacts",
          avgConversationTime: "Avg. Conversation Time",
          finished: "Finished",
          avgWaitTime: "Avg. Wait Time",
        },
        filters: {
          filterType: "Filter Type",
          dateFilter: "Date Filter",
          periodFilter: "Period Filter",
          startDate: "Start Date",
          endDate: "End Date",
          period: "Period",
          noneSelected: "None selected",
          last3Days: "Last 3 days",
          last7Days: "Last 7 days",
          last15Days: "Last 15 days",
          last30Days: "Last 30 days",
          last60Days: "Last 60 days",
          last90Days: "Last 90 days",
          filter: "Filter",
          configureFilter: "Configure the filter",
        },
        table: {
          name: "Name",
          ratings: "Ratings",
          avgServiceTime: "Avg. Service Time",
          currentStatus: "Status (Current)",
        },
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
          user: {
            title: "Conversations Chart",
            totalConversationsByUsers: "Total Conversations by Users",
          },
          date: {
            total: "Total",
            title: "Conversations Chart",
            error: "Error fetching ticket information",
          },
          appointmentsAtendent: {
            label: "Number of Tickets",
            title: "Tickets by Attendants",
            description: "Find out which attendants are most productive",
            byDepartments: "Tickets by Departments/Queues",
            departmentsDescription: "Find out which departments are most sought after",
          },
          rushHour: {
            title: "Peak Hours - Message Exchange",
            description: "Number of messages received and sent each hour of the day.",
            hourOfDay: "Hour of Day",
            quantity: "Quantity",
          },
          departamentRatings: {
            title: "Ratings by Department/Queue",
            description: "See the average ratings for each department/queue.",
            quantity: "Quantity",
          },
          dateLabels: {
            start: "Start",
            end: "End",
          },
          common: {
            filter: "Filter",
            quantity: "Quantity",
          },
        },
      },
      announcementModal: {
        form: {
          sendToAllCompanies: "Send to all companies",
          showToSuperadmin: "Show to superadmin",
          sendToAllCompaniesDesc: "When enabled, the announcement will be sent to all registered companies",
          showToSuperadminDesc: "When disabled, the announcement will not be displayed for superadmins",
        },
        buttons: {
          preview: "Preview",
        },
        toasts: {
          successAllCompanies: "Announcement sent successfully to {{count}} {{count, plural, one {company} other {companies}}}!",
        },
      },
      kanban: {
        open: "Open",
        tooltips: {
          notes: "Notes",
          createSchedule: "Create appointment",
          goToConversation: "Go to conversation",
        },
        menu: {
          finalize: "Finalize",
        },
        dialog: {
          unlinkTicket: "Unlink Ticket",
          deleteTicket: "Delete Ticket",
          unlinkMessage: "Are you sure you want to unlink this ticket from all kanban tags? The chat will remain intact.",
          deleteMessage: "Warning: This action is irreversible. All messages will be lost.",
          cancel: "Cancel",
          confirm: "Confirm",
        },
      },
      emojiGifStickerPicker: {
        searchGifs: "Search GIFs",
        stickers: {
          selectStickers: "Select the stickers",
          selected_one: "{{count}} sticker selected",
          selected_other: "{{count}} stickers selected",
          selectAll: "Select All",
          clear: "Clear",
          delete: "Delete ({{count}})",
          noStickers: "No stickers saved. Click + to add.",
          deleteStickerTitle: "Delete Sticker",
          deleteStickerMessage: "Do you really want to delete this sticker?",
          deleteMultipleTitle: "Delete Selected Stickers",
          deleteMultipleMessage: "Do you really want to delete {{count}} selected sticker(s)? This action cannot be undone.",
          loadError: "Error loading",
        },
      },
      legal: {
        back: "Back to signup",
        privacy: {
          title: "Privacy Policy",
          lastUpdate: "Last update",
          s1: {
            title: "1. Introduction",
            content: "This Privacy Policy describes how we collect, use, and protect your information when using our WhatsApp customer service SaaS platform. We are committed to ensuring the protection of your privacy and compliance with the General Data Protection Regulation (GDPR) and local laws.",
          },
          s2: {
            title: "2. Data Collection",
            content: "We collect information necessary for the provision of our services, including:",
            items: [
              "Registration information (name, email, phone, company).",
              "Authentication data and access logs.",
              "Content of messages processed through our API (strictly for service purposes).",
              "Cookies and browsing data to improve user experience.",
            ],
          },
          s3: {
            title: "3. Use of Information",
            content: "The collected data is used to:",
            items: [
              "Manage your account and provide technical support.",
              "Process and organize your customer service via WhatsApp.",
              "Ensure platform security and prevent fraud.",
              "Send important communications about the system and updates.",
            ],
          },
          s4: {
            title: "4. Data Security",
            content: "We implement rigorous technical and organizational measures to protect your data against unauthorized access, alteration, disclosure, or destruction. This includes encryption of data at rest and in transit, firewalls, and regular security audits.",
          },
          s5: {
            title: "5. Information Sharing",
            content: "We do not sell your personal data to third parties. Sharing occurs only when necessary for service operation (e.g., cloud infrastructure providers) or by legal requirement.",
          },
          s6: {
            title: "6. Your Rights",
            content: "Depending on your location, you have the right to:",
            items: [
              "Confirm the existence of data processing.",
              "Access your personal data stored by us.",
              "Correct incomplete or inaccurate data.",
              "Request anonymization or deletion of unnecessary data.",
              "Revoke your consent at any time.",
            ],
          },
          s7: {
            title: "7. Contact",
            content: "If you have questions about this Privacy Policy or how we handle your data, please contact our Data Protection Officer (DPO) through the system support.",
          },
        },
        terms: {
          title: "Terms of Service",
          lastUpdate: "Last update",
          s1: {
            title: "1. Acceptance of Terms",
            content: "By registering and using our platform, you agree to comply with these Terms of Service. If you do not agree with any part of these terms, you may not access or use the service.",
          },
          s2: {
            title: "2. Service Description",
            content: "We provide a SaaS solution for multi-channel service management via WhatsApp. The service includes a chat interface, ticket management, reports, and automation. We reserve the right to update or modify platform features for continuous improvement.",
          },
          s3: {
            title: "3. User Responsibilities",
            content: "The user agrees to:",
            items: [
              "Provide accurate information and keep it updated.",
              "Use the service in compliance with the official WhatsApp/Meta policies.",
              "Not use the platform to send spam, illegal, or abusive content.",
              "Maintain the confidentiality of your access credentials.",
            ],
          },
          s4: {
            title: "4. Payments and Subscriptions",
            content: "Access to the system is based on subscription plans. Delay in payment may result in temporary suspension or cancellation of services. Prices and fees may be adjusted with prior notice.",
          },
          s5: {
            title: "5. Intellectual Property",
            content: "All source code, design, logos, and content of the platform are the exclusive property of our company or licensors. Reverse engineering or unauthorized reproduction of the system is prohibited.",
          },
          s6: {
            title: "6. Limitation of Liability",
            content: "We are not responsible for interruptions caused by failures in third-party infrastructure (such as WhatsApp itself or internet providers) or improper use of the platform by the user resulting in number bans from Meta.",
          },
          s7: {
            title: "7. Termination",
            content: "You can cancel your account at any time through the financial panel. We reserve the right to terminate accounts that seriously violate these terms of use.",
          },
          s8: {
            title: "8. Changes to Terms",
            content: "We may revise these terms periodically. Significant changes will be notified through the system or by email. Continued use after changes constitutes acceptance of the new terms.",
          },
        },
      },
      dashboard: {
        cards: {
          activeConnections: "Active Connections",
          companies: "Companies",
          inConversation: "In Conversation",
          waiting: "Waiting",
          newContacts: "New Contacts",
          avgConversationTime: "Avg. Conv. Time",
          finished: "Finished",
          avgWaitTime: "Avg. Wait Time",
        },
        filters: {
          filterType: "Filter Type",
          dateFilter: "Filter by Date",
          periodFilter: "Filter by Period",
          dateFrom: "Start Date",
          dateTo: "End Date",
          period: "Period",
          noneSelected: "None selected",
          last3Days: "Last 3 days",
          last7Days: "Last 7 days",
          last15Days: "Last 15 days",
          last30Days: "Last 30 days",
          last60Days: "Last 60 days",
          last90Days: "Last 90 days",
          filter: "Filter",
        },
        messages: {
          parameterizeFilter: "Parameterize the filter",
        },
        charts: {
          ticketsCreated: "Tickets Created: ",
          tickets: "Tickets",
          conversationsChart: "Conversations Chart",
          quantity: "Quantity",
          hourOfDay: "Hour of Day",
          errorLoadingData: "Error loading conversation data",
        },
      },
    },
  },
};

export { messages };